import { gql } from '@apollo/client'
import { useLazyQuery } from '@apollo/client/react'
import type { Customer, FilterQuery } from '@ztechapps/common.contract'

export const getCompanyUpsAccountsQuery = gql`
  query getCompanyUpsAccounts($filter: JSON, $options: JSON) {
    getCompanyUpsAccounts(filter: $filter, options: $options) {
      _id
      profile {
        _id
        name
      }
      ups {
        _id
        account
        countryCode
        postalCode
      }
    }
  }
`

export type UseCompanyUpsAccountsResult = {
  data: Customer[] | undefined
  loading: boolean
  error: any
  loadCompanyUpsAccounts: (companyId: string) => void
}

export const useCompanyUpsAccounts = (): UseCompanyUpsAccountsResult => {
  const [loadQuery, { data, loading: queryLoading, error }] = useLazyQuery<{ getCompanyUpsAccounts: Customer[] }>(
    getCompanyUpsAccountsQuery,
    {
      fetchPolicy: 'cache-and-network',
    }
  )

  const loadCompanyUpsAccounts = (id: string) => {
    if (!id) return

    const filter: FilterQuery<Customer> = {
      'company._id': id,
    }

    loadQuery({
      variables: {
        filter,
        options: undefined,
      },
    })
  }

  const loading = queryLoading
  const finalData = data?.getCompanyUpsAccounts

  return {
    data: finalData,
    loading,
    error,
    loadCompanyUpsAccounts,
  }
}
